import React from 'react';
import classnames from 'classnames';
import edgeArrowBlack from '../../../../common/assets/pagination-arrow-to-edge-black.svg';
import gotoArrowBlack from '../../../../common/assets/pagination-arrow-black.svg';
import edgeArrowGray from '../../../../common/assets/pagination-arrow-to-edge-gray.svg';
import gotoArrowGray from '../../../../common/assets/pagination-arrow-gray.svg';
import styles from './styles.module.scss';

const pageSize = 15;

const DataTableView = ({
                         getTableProps,
                         getTableBodyProps,
                         headerGroups,
                         prepareRow,
                         page = 0,
                         canPreviousPage,
                         canNextPage,
                         pageCount = 0,
                         gotoPage,
                         nextPage,
                         previousPage,
                         totalResultCount,
                         showPagination,
                         pageIndex = 0,
                       }) => {
  const currentRange = `${(pageIndex) * pageSize + 1} - ${Math.min((pageIndex) * pageSize + pageSize, totalResultCount)}`;

  const mapHeader = () => {
    return headerGroups.map((headerGroup, ind) => (
      <tr
        {...headerGroup.getHeaderGroupProps()}
        className={styles.row}
        key={ind}
      >
        {headerGroup.headers.map((column, ind) => (
            <th
              {...column.getHeaderProps()}
              className={styles.headerCell}
              key={ind}
            >
              {Array.isArray(column.Header)
                ? column.Header.map(item => <div>{item}</div>)
                : column.render('Header')
              }
            </th>
          ))}
      </tr>
    ));
  };

  const mapRows = () => {
    return page.map((row, ind) => {
      prepareRow(row);

      return (
        <tr
          {...row.getRowProps()}
          key={ind}
          className={styles.row}
        >
          {mapCells(row)}
        </tr>
      );
    });
  };

  const mapCells = (row) => {
    return row.cells.map((cell, ind) => {
      return (
        <td
          {...cell.getCellProps()}
          className={styles.cell}
          key={ind}
        >
          {cell.render('Cell')}
        </td>
      );
    });
  };

  return (
    <>
      <div
        className={styles.formContainer}>
        <table {...getTableProps()} className={styles.form}>
          <thead className={styles.thead}>
          {mapHeader()}
          </thead>
          <tbody {...getTableBodyProps()}>
          {mapRows()}
          </tbody>
        </table>
      </div>
      {(showPagination && totalResultCount) ? (
        <div
          className={styles.pagination}>
          <div className={classnames(styles.pageInfoLabel, styles.range)}>
            {currentRange}
            <span>מתוך</span>
            {totalResultCount}
          </div>
          <button
            type="button"
            onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}
            className={classnames(styles.arrow, styles.start)}
          >
            <img
              src={canNextPage ? edgeArrowBlack : edgeArrowGray}
              className={canNextPage ? styles.reverse : ''}
              alt="go to end"
            />
          </button>
          <button
            type="button"
            onClick={() => nextPage()} disabled={!canNextPage}
            className={styles.arrow}
          >
            <img
              src={canNextPage ? gotoArrowBlack : gotoArrowGray}
              className={(canNextPage) ? styles.reverse : ''}
              alt="next page"
            />
          </button>
          <div className={classnames(styles.pageInfoLabel, styles.current)}>
            <span>עמוד</span>
            {pageIndex + 1}
          </div>
          <button
            type="button"
            onClick={() => previousPage()}
            disabled={!canPreviousPage || (pageIndex === 0)}
            className={styles.arrow}
          >
            <img
              src={(canPreviousPage && (pageIndex !== 0)) ? gotoArrowBlack : gotoArrowGray}
              className={(canPreviousPage && (pageIndex !== 0)) ? '' : styles.reverse}
              alt="previous page"
            />
          </button>
          <button
            type="button"
            onClick={() => gotoPage(0)} disabled={!canPreviousPage}
            className={classnames(styles.arrow, styles.end)}
          >
            <img
              src={(canPreviousPage) ? edgeArrowBlack : edgeArrowGray}
              className={(canPreviousPage) ? '' : styles.reverse}
              alt="go to start"
            />
          </button>
        </div>
      ) : null}
    </>
  );
};

export default DataTableView;